







import {
    Component, Mixins, Model, Watch,
} from 'vue-property-decorator';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import ProfileDetails from '@/components/settings/ProfileDetails.vue';
import UserIntegrationMixin from '@/mixins/vue/UserIntegrationMixin';


@Component({
    components: {
        // ProfileSettingForm,
        ProfileDetails,
    },
})
export default class ProfileSettings extends Mixins(
    IsMobileMixin, UserIntegrationMixin,
) {
    public created() {
        this.integrateUserFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });
    }
}
